import unescapedText from 'I18n/utils/unescapedText';
function isFscSeatCategory(category) {
  return category === 'GTM_SEATS' || category === 'OPS_SEATS';
}
function getSeatCopy(category) {
  if (category === 'GTM_SEATS') {
    return {
      title: unescapedText('publicFscConfigure.compareSeats.seatNames.GTM_SEATS'),
      description: unescapedText('publicFscConfigure.compareSeats.seatDescriptions.GTM_SEATS')
    };
  }
  return {
    title: unescapedText('publicFscConfigure.compareSeats.seatNames.OPS_SEATS'),
    description: unescapedText('publicFscConfigure.compareSeats.seatDescriptions.OPS_SEATS')
  };
}
export function getFscCompareSeats(tierOption, products, pricesByApiName) {
  const {
    productApiName,
    tierProducts
  } = tierOption;
  const apiNames = [productApiName, ...tierProducts.filter(apiName => apiName !== productApiName)];
  return apiNames.flatMap(apiName => {
    var _products$apiName;
    const category = products === null || products === void 0 || (_products$apiName = products[apiName]) === null || _products$apiName === void 0 ? void 0 : _products$apiName.skuCategoryName;
    if (!isFscSeatCategory(category)) return [];
    return [Object.assign({
      apiName
    }, getSeatCopy(category), {
      pricePerSeat: pricesByApiName.get(apiName)
    })];
  });
}